import {
  GOOGLE_CLICK_ID_PARAMS,
  UTM_QUERY_PARAMS,
} from 'shared/presentation/constants';

import {
  INTERNAL_PROMO,
  INTERNAL_PROMO_ROUTES,
  UTM,
} from '../AppContext.constants';

/**
 * Decide quais cookies de UTM/internal_promo devem ser gravados a partir da
 * query string atual, sem aplicar nenhum efeito colateral.
 *
 * Em rotas de elementos internos (ver INTERNAL_PROMO_ROUTES), utm_campaign e
 * utm_medium são remapeados para internal_promo/internal_promo_placement em
 * vez dos campos de UTM reais — a UTM de aquisição paga já salva nunca é
 * sobrescrita nesse caso.
 */
export default function resolveUtmCookieUpdates(searchParams, pathname) {
  const isInternalPromoRoute = INTERNAL_PROMO_ROUTES.includes(pathname);
  const updates = [];

  for (const [key, value] of searchParams.entries()) {
    if (
      !UTM_QUERY_PARAMS.includes(key) ||
      GOOGLE_CLICK_ID_PARAMS.includes(key)
    ) {
      continue;
    }

    if (isInternalPromoRoute) {
      if (key === UTM.CAMPAIGN) {
        updates.push({ key: INTERNAL_PROMO.PROMO, value });
      } else if (key === UTM.MEDIUM) {
        updates.push({ key: INTERNAL_PROMO.PLACEMENT, value });
      }
      continue;
    }

    updates.push({ key, value });
  }

  return updates;
}
